

function Privacypolicy(props) {
  return 'Privacypolicy'
}
export default Privacypolicy;